import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";

import { LangProvider } from "./context/LangContext";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";

import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import WhatsAppFab from "./components/WhatsAppFab";
import FallbackBanner from "./components/FallbackBanner";

import Home from "./pages/Home";
import About from "./pages/About";
import Services from "./pages/Services";
import Products from "./pages/Products";
import ProductDetail from "./pages/ProductDetail";
import Portfolio from "./pages/Portfolio";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Vlogs from "./pages/Vlogs";
import VlogDetail from "./pages/VlogDetail";
import Booking from "./pages/Booking";
import Contact from "./pages/Contact";
import Quote from "./pages/Quote";

import AdminLogin from "./pages/admin/AdminLogin";
import ForgotPassword from "./pages/admin/ForgotPassword";
import ResetPassword from "./pages/admin/ResetPassword";
import AdminLayout from "./pages/admin/AdminLayout";
import AmateAudio from "./pages/AmateAudio";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminServices from "./pages/admin/AdminServices";
import AdminPortfolio from "./pages/admin/AdminPortfolio";
import AdminBlog from "./pages/admin/AdminBlog";
import AdminVlogs from "./pages/admin/AdminVlogs";
import AdminInbox from "./pages/admin/AdminInbox";
import AdminUsers from "./pages/admin/AdminUsers";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <div className="grain-overlay min-h-screen flex flex-col">
      <FallbackBanner />
      <Header />
      <main className="flex-1 relative z-10">
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
        <AuthProvider>
          <LangProvider>
            <CartProvider>
              <ScrollToTop />
              <Toaster theme="dark" position="top-right" toastOptions={{
                style: { background: "#121216", border: "1px solid #2a2a35", color: "#f0f0f5", borderRadius: 0 },
              }} />
              <Routes>
                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin/forgot-password" element={<ForgotPassword />} />
                <Route path="/admin/reset-password" element={<ResetPassword />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminDashboard />} />
                  <Route path="products" element={<AdminProducts />} />
                  <Route path="services" element={<AdminServices />} />
                  <Route path="portfolio" element={<AdminPortfolio />} />
                  <Route path="blog" element={<AdminBlog />} />
                  <Route path="vlogs" element={<AdminVlogs />} />
                  <Route path="inbox" element={<AdminInbox />} />
                  <Route path="users" element={<AdminUsers />} />
                </Route>

                {/* Public */}
                <Route element={<PublicLayout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/products" element={<Products />} />
                  <Route path="/products/:id" element={<ProductDetail />} />
                  <Route path="/portfolio" element={<Portfolio />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/vlogs" element={<Vlogs />} />
                  <Route path="/vlogs/:slug" element={<VlogDetail />} />
                  <Route path="/booking" element={<Booking />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/quote" element={<Quote />} />
                  <Route path="/brands/amate-audio" element={<AmateAudio />} />
                </Route>
              </Routes>
            </CartProvider>
            </LangProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
